import React from "react";
import clsx from "clsx";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: "none" | "sm" | "md" | "lg";
  hover?: boolean;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({
  children,
  className,
  padding = "md",
  hover = false,
  onClick,
}) => {
  const paddings = {
    none: "",
    sm: "p-4",
    md: "p-6",
    lg: "p-8",
  };

  return (
    <div
      onClick={onClick}
      className={clsx(
        "bg-white rounded-lg border border-gray-200",
        paddings[padding],
        hover &&
          "transition-all duration-300 hover:shadow-lg hover:border-blazerex-green",
        onClick && "cursor-pointer",
        className
      )}
    >
      {children}
    </div>
  );
};
